module.exports = __webpack_public_path__ + "static/media/pe.5cda7a60.ogg";